<template>
    <main-layout active-menu="profile">
        <template #pageTitle>
            <h2 class="mb-1">User Profile</h2>
            <span class="sm-text"></span>
        </template>

        <div>
            <div class="title-col2">
                <h2 class="sm-title my-4">Profile</h2>
            </div>
            <div class="repository-card-style me-0 mb-3" v-if="$page.props.jetstream.canUpdateProfileInformation">
                <update-profile-information-form :user="$page.props.user" />

                <jet-section-border />
            </div>

            <div class="repository-card-style me-0 mb-3" v-if="$page.props.jetstream.canUpdatePassword">
                <update-password-form />

                <jet-section-border />
            </div>

            <div class="repository-card-style me-0 mb-3">
                <update-username-form :user="$page.props.user" />

                <jet-section-border />
            </div>

            <div class="repository-card-style me-0 mb-3" v-if="$page.props.jetstream.canManageTwoFactorAuthentication">
                <two-factor-authentication-form/>

                <jet-section-border />
            </div>
            <div class="repository-card-style me-0 mb-3">
                <logout-other-browser-sessions-form :sessions="sessions" />
            </div>
            <div class="repository-card-style me-0 mb-3">
                <template v-if="$page.props.jetstream.hasAccountDeletionFeatures">
                    <jet-section-border />

                    <delete-user-form />
                </template>
            </div>
        </div>
    </main-layout>
</template>

<script>
    import MainLayout from '@/Layouts/MainLayout'
    import DeleteUserForm from './DeleteUserForm'
    import JetSectionBorder from '@/Jetstream/SectionBorder'
    import LogoutOtherBrowserSessionsForm from './LogoutOtherBrowserSessionsForm'
    import TwoFactorAuthenticationForm from './TwoFactorAuthenticationForm'
    import UpdatePasswordForm from './UpdatePasswordForm'
    import UpdateProfileInformationForm from './UpdateProfileInformationForm'
    import UpdateUsernameForm from "@/Pages/Profile/UpdateUsernameForm";

    export default {
        props: ['sessions'],

        components: {
            UpdateUsernameForm,
            MainLayout,
            DeleteUserForm,
            JetSectionBorder,
            LogoutOtherBrowserSessionsForm,
            TwoFactorAuthenticationForm,
            UpdatePasswordForm,
            UpdateProfileInformationForm,
        },
    }
</script>
